import _defineProperty from "@babel/runtime/helpers/defineProperty";
import countries from "./countries";
var ids = _defineProperty({}, countries.ES, {
  NATIONAL_ID: 'NATIONAL_ID',
  FOREIGN_NATIONAL_NUMBER: 'FOREIGN_NATIONAL_NUMBER'
});
var idsFormatterSpecs = _defineProperty({}, countries.ES, _defineProperty(_defineProperty({}, ids[countries.ES].NATIONAL_ID, [{
  "char": /\d/,
  repeat: 8
}, {
  "char": /[A-Z]/,
  repeat: 1
}]), ids[countries.ES].FOREIGN_NATIONAL_NUMBER, [{
  "char": /[XYZ]/,
  repeat: 1
}, {
  "char": /\d/,
  repeat: 7
}, {
  "char": /[A-Z]/,
  repeat: 1
}]));
var idsFormats = _defineProperty({}, countries.ES, _defineProperty(_defineProperty({}, ids[countries.ES].NATIONAL_ID, '11111111L'), ids[countries.ES].FOREIGN_NATIONAL_NUMBER, 'Y1111111L'));
var idsLength = _defineProperty({}, countries.ES, _defineProperty(_defineProperty({}, ids[countries.ES].NATIONAL_ID, 9), ids[countries.ES].FOREIGN_NATIONAL_NUMBER, 9));
export default {
  ids: ids,
  idsFormatterSpecs: idsFormatterSpecs,
  idsFormats: idsFormats,
  idsLength: idsLength
};